module["exports"] = [
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/tr/address/postcode.js
// module id = 1901
// module chunks = 0